//这JS用来保存数据
export default {
	setInitData,
	getInitData,
	isShowQRimg,
	passwordedWatch,
	verifyCode
}

//二维码是否显示了一次
var isShowQRimg = false;
//是否已经输入过密码
var passwordedWatch = false;

var verifyCode = '';

function setInitData(data){
	//initData = data;
	sessionStorage.setItem('initData', JSON.stringify(data));
}
function getInitData(){
	var initData = JSON.parse(sessionStorage.getItem('initData'))
	if(initData == null){
		return false;
	}else{
		return initData;
	}
}




// WEBPACK FOOTER //
// ./src/kits/data.js